import { Stack, Typography } from '@mui/material';
import React from 'react';
import Error404Icon from './shared/icon/error404-icon';


const ErrorPage = () => {
    return (
        <>
           <Stack height={'100vh'} textAlign={'center'} alignItems={'center'} justifyContent={'center'}>
            <Error404Icon />
            <Typography variant="h2" color="initial">Page not found</Typography>
            <Typography variant="h6" color="initial">The page you are looking for not found</Typography>
           </Stack>
        </>
    );
};

export default ErrorPage;
